
            const data = {"name":"glyph/12/email","data":{"width":"12","height":"12","viewBox":"0 0 12 12","data":"<g _fill=\"#444\"><path pid=\"0\" d=\"M10 6.136V9H2V6.136L0 4.8V10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V4.8Z\" data-color=\"color-2\"/><path pid=\"1\" d=\"M12 3 6 7 0 3V2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1Z\"/></g>","originalColors":[{"type":"fill","color":"#444"}],"stopColors":[]}}
        
                    module.exports = data
                    